import { useContext, useEffect, useState } from 'react'

// others
import { FeeType, PaginationPayload, useFetchAllFeeTypesLazyQuery } from '../../generated'
import { GRAPHQL_QUERY_POLICY, PAGE_LIMIT, QUERY_PARAMS } from '../constants'
import { AppContext } from '../context'
import { ActionType } from '../context/AppContextReducer'
import { useDebounce } from 'use-debounce'
import { useSearchParams } from 'react-router-dom'

export const useFeeTypes = ({ fetchFeeType = true }: { fetchFeeType?: boolean }) => {
  const [feeTypes, setFeeTypes] = useState<FeeType[]>([])
  const [pagination, setPagination] = useState<PaginationPayload | null>({})
  const { currentPage, searchValue, dispatch: reducerDispatch } = useContext(AppContext)

  const [searchParams] = useSearchParams()

  const queryParam = searchParams.get(QUERY_PARAMS.QUERY)
  const [debouncedValue] = useDebounce(searchValue || queryParam, 500)

  const [fetchAllFeeTypes, { loading, refetch }] = useFetchAllFeeTypesLazyQuery({
    ...GRAPHQL_QUERY_POLICY,
    variables: undefined,
    onError() {
      setFeeTypes([])
      reducerDispatch({ type: ActionType.SET_IS_LOADING, isLoading: false })
    },
    onCompleted(data) {
      if (data) {
        const { fetchAllFeeTypes } = data
        const { feeTypes, pagination = {} } = fetchAllFeeTypes
        setPagination(pagination)
        if (feeTypes) setFeeTypes(feeTypes as FeeType[])
      }
    }
  })

  useEffect(() => {
    fetchFeeType &&
      fetchAllFeeTypes({
        variables: {
          fetchFeeTypes: {
            keyword: debouncedValue,
            paginationOptions: {
              limit: PAGE_LIMIT,
              page: currentPage
            }
          }
        }
      })
  }, [currentPage, fetchAllFeeTypes, debouncedValue, fetchFeeType])

  return { feeTypes, pagination, loading, refetch }
}
